import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface SiteBranding {
  siteTitle: string;
  siteTitleAccent: string;
  logoUrl: string | null;
}

const defaultBranding: SiteBranding = {
  siteTitle: "Perfecte",
  siteTitleAccent: "Zorgmatch",
  logoUrl: null,
};

export const useSiteBranding = () => {
  return useQuery({
    queryKey: ["site-branding"],
    queryFn: async (): Promise<SiteBranding> => {
      const { data, error } = await supabase
        .from("admin_settings")
        .select("setting_key, setting_value")
        .in("setting_key", ["site_title", "site_title_accent", "site_logo_url"]);

      if (error) {
        console.error("Error fetching site branding:", error);
        return defaultBranding;
      }

      const settings = data?.reduce((acc, item) => {
        acc[item.setting_key] = item.setting_value;
        return acc;
      }, {} as Record<string, string | null>) || {};

      return {
        siteTitle: settings.site_title || defaultBranding.siteTitle,
        siteTitleAccent: settings.site_title_accent || defaultBranding.siteTitleAccent,
        logoUrl: settings.site_logo_url || null,
      };
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
